<div mat-dialog-content class="message-content">
    <mg-visual-great-success></mg-visual-great-success>
    <p
        *ngIf="referralCode !== 'MissGreen' && referralCode !== 'missgreen'"
        i18n="@@deal.summary.referral-popup.default"
    >
        Congratulations, through the code of ambassador {{ referralCode }} you'll get a nice discount on your monthly
        leasing price! The discount has been directed applied to your offer.
    </p>
    <p
        *ngIf="referralCode === 'MissGreen' || referralCode === 'missgreen'"
        i18n="@@deal.summary.referral-popup.missgreen"
    >
        Fantastic MissGreen, the discount of 15 euro per month has been applied to your personalized lease offer. We
        can't wait to welcome you to MisterGreen!
    </p>
</div>
